import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const KEY = "fd-cookie-consent";

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const v = localStorage.getItem(KEY);
    if (!v) setVisible(true);
  }, []);

  const set = (value) => {
    localStorage.setItem(KEY, value);
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      data-testid="cookie-banner"
      className="fixed bottom-4 left-4 right-4 md:left-auto md:right-6 md:bottom-6 md:max-w-md z-50 bg-white border border-gray-200 shadow-2xl rounded-2xl p-6"
    >
      <div className="text-sm font-bold text-[#0A3B2C] mb-2" style={{ fontFamily: "Outfit, sans-serif" }}>
        Wir respektieren Ihre Privatsphäre.
      </div>
      <p className="text-xs text-gray-600 leading-relaxed mb-4">
        Notwendige Cookies sind erforderlich, damit die Seite technisch fehlerfrei funktioniert.
        Mit Ihrer Einwilligung verwenden wir zusätzlich Analyse- und Marketing-Cookies. Details in unserer{" "}
        <Link to="/datenschutz" className="underline hover:no-underline text-[#0A3B2C]">Datenschutzerklärung</Link>.
      </p>
      <div className="flex flex-wrap gap-2">
        <button
          data-testid="cookie-accept-all"
          onClick={() => set("all")}
          className="flex-1 bg-[#0A3B2C] text-white hover:bg-[#072A1F] transition px-4 py-2.5 rounded-md text-xs font-semibold"
        >
          Alle akzeptieren
        </button>
        <button
          data-testid="cookie-reject"
          onClick={() => set("necessary")}
          className="flex-1 bg-white text-[#0A3B2C] border border-[#0A3B2C]/20 hover:border-[#0A3B2C] transition px-4 py-2.5 rounded-md text-xs font-semibold"
        >
          Ablehnen
        </button>
      </div>
      <Link
        to="/cookie-einstellungen"
        className="mt-3 inline-block text-xs text-gray-500 hover:text-[#0A3B2C] underline"
        data-testid="cookie-settings-link"
      >
        Einstellungen anpassen
      </Link>
    </div>
  );
}
